import { Box, Drawer, Grid, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import GoogleSearchBox from '../../../../../common/components/maps/googlesearchbox/GoogleSearchBox';
import PhoneNoTextField from '../../../../../common/components/customized/customtextfield/PhoneNoTextField';
import CustomTextField from '../../../../../common/components/customized/customtextfield/CustomTextField';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import {
  addCustomer,
  clearCustomersAction,
  updateCustomer
} from '../../../redux/reducer/deliveryTrackingSlices/customerDeliverySlice';

const schema: any = yup.object().shape({
  firstName: yup.string().required('Enter the first name'),
  lastName: yup.string().required('Enter the last name'),
  contactNumber: yup.string().required('Enter the contact number'),
  deliveryAddress: yup.object().shape({
    delivery: yup.string().required('Enter delivery address'),
    deliverableLat: yup.number().required('Enter delivery latitude'),
    deliverableLng: yup.number().required('Enter delivery longitude')
  })
});
interface AddCustomerDelivery {
  open: boolean;
  setOpen: any;
  roleType: string;
  filteredRow: any;
}
interface TextField {
  id: string;
  label: string;
  field: 'firstName' | 'lastName' | 'contactNumber' | 'deliveryAddress';
  placeholder: string;
  inputProps: {
    maxLength?: number;
    style?: React.CSSProperties;
  };
  options?: { id: string; label: string }[];
}

const AddCustomerDelivery = ({
  open,
  setOpen,
  roleType,
  filteredRow
}: AddCustomerDelivery) => {
  const [deliveryLocation, setDeliveryLocation] = useState<any>([
    { delivery: '', deliverableLat: 0, deliverableLng: 0 }
  ]);
  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector(state => state.customerAdd);
  const { isLoading: updateLoading } = useAppSelector(state => state.customerUpdate);
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    resetField,
    clearErrors,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const textField: TextField[] = [
    {
      id: '1',
      label: 'First Name',
      field: 'firstName',
      placeholder: 'First Name',
      inputProps: { maxLength: 40 }
    },
    {
      id: '2',
      label: 'Last Name',
      field: 'lastName',
      placeholder: 'Last Name',
      inputProps: { maxLength: 40 }
    },
    {
      id: '3',
      label: 'Contact Number',
      field: 'contactNumber',
      placeholder: 'Contact Number',
      inputProps: { maxLength: 10 }
    },
    {
      id: '4',
      label: 'Delivery Address',
      field: 'deliveryAddress',
      placeholder: 'Delivery Address',
      inputProps: { maxLength: 10 }
    }
  ];

  const onSubmit = async (data: any) => {
    if (filteredRow) {
      let updatePayload: any = {
        firstName: data.firstName,
        lastName: data.lastName,
        contactNumber: data.contactNumber,
        deliveryAddress: data.deliveryAddress.delivery,
        deliverableLat: data.deliveryAddress.deliverableLat,
        deliverableLng: data.deliveryAddress.deliverableLng
      };
      let pay: { updatePayload: any; customerId: any; pageNo: number; pageSize: number } =
        {
          updatePayload: updatePayload,
          customerId: filteredRow.customerId,
          pageNo: 1,
          pageSize: 12
        };
      await dispatch(updateCustomer(pay));
      setOpen(false);
    } else {
      await dispatch(
        addCustomer({
          data: {
            firstName: data.firstName,
            lastName: data.lastName,
            contactNumber: data.contactNumber,
            deliveryAddress: data.deliveryAddress.delivery,
            deliverableLat: data.deliveryAddress.deliverableLat,
            deliverableLng: data.deliveryAddress.deliverableLng,
            tempCustomer: false
          },
          pageNo: 1,
          pageSize: 12
        })
      );
      setOpen(false);
    }
  };

  const handleClose = () => {
    reset();
    setOpen(false);
  };

  useEffect(() => {
    setValue('firstName', filteredRow?.firstName);
    setValue('lastName', filteredRow?.lastName);
    setValue('contactNumber', filteredRow?.contactNumber);
    setValue('deliveryAddress', {
      delivery: filteredRow?.deliveryAddress,
      deliverableLat: filteredRow?.deliverableLat,
      deliverableLng: filteredRow?.deliverableLng
    });
    setDeliveryLocation([
      {
        delivery: filteredRow?.deliveryAddress,
        deliverableLat: filteredRow?.deliverableLat,
        deliverableLng: filteredRow?.deliverableLng
      }
    ]);
  }, [filteredRow]);

  return (
    <Box p={2}>
      <Drawer
        anchor='right'
        open={open}
        sx={{ zIndex: 1 }}
        onClose={() => {
          setOpen(false);
          reset();
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px !important'
          }}
        >
          <Typography sx={{ fontWeight: 700 }}>{roleType}</Typography>
          <Box
            sx={{ display: 'flex', flexDirection: 'column', gap: 15 }}
            className='customer-delivery-container'
          >
            <Box component={'form'} onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={1}>
                {textField?.map(item => (
                  <Grid item key={item.id} xs={12} className='customer-item'>
                    {item?.id === '4' ? (
                      <GoogleSearchBox
                        id={item.id}
                        name={item.field}
                        control={control}
                        label={item.label}
                        placeholder='Search Location..'
                        value={deliveryLocation && deliveryLocation[0]?.delivery}
                        onchange={(data: any) => {
                          if (!data.target.value) {
                            setDeliveryLocation(null);
                            resetField('deliveryAddress');
                          }
                        }}
                        setAddress={(address: any) => {
                          setDeliveryLocation([
                            {
                              delivery: address?.formatted_address,
                              deliverableLat: address?.geometry?.location?.lat(),
                              deliverableLng: address?.geometry?.location?.lng()
                            }
                          ]);
                          setValue('deliveryAddress', {
                            delivery: address?.formatted_address,
                            deliverableLat: address?.geometry?.location?.lat(),
                            deliverableLng: address?.geometry?.location?.lng()
                          });
                          clearErrors('delivery');
                        }}
                      />
                    ) : item.id === '3' ? (
                      <Controller
                        name={item.field}
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <PhoneNoTextField
                            {...field}
                            label={item.label}
                            setValue={setValue}
                            country={'in'}
                            style='share'
                            error={Boolean(errors?.contactNumber)}
                            helperText={
                              typeof errors?.contactNumber?.message === 'string'
                                ? errors.contactNumber.message
                                : ''
                            }
                          />
                        )}
                      />
                    ) : (
                      <CustomTextField
                        key={item.id}
                        control={control}
                        name={item.field}
                        placeholder={item.placeholder}
                        id={item.id}
                        label={item.label}
                      />
                    )}
                  </Grid>
                ))}
              </Grid>
              <Box sx={{ marginTop: '5%', display: 'flex', gap: '15px' }}>
                <CustomButton
                  className='saveChanges'
                  type='submit'
                  category={roleType}
                  loading={filteredRow ? updateLoading : isLoading}
                />
                <CustomButton
                  className='cancel'
                  category='Cancel'
                  onClick={() => {
                    handleClose();
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default AddCustomerDelivery;
